import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import utilsUsers from "../_Utils/utilsUsers";
import { AddCircleOutline, AlignHorizontalLeftRounded, ArrowCircleRightSharp, ArrowCircleUp, ContactlessOutlined, HighlightOff, RemoveCircleOutline } from "@mui/icons-material";
import { MasterContext, OrderContext, UserContext } from "../ContextApi/context";
import { Checkbox } from "@material-ui/core";
import utilsOrders from "../_Utils/utilsOrders";
import PopUpMsg from "../DTechComp/PopUpMsg";

import Scroll from 'react-scroll';
import { Helmet } from "react-helmet";
import ConnUrls from "../Connections/ConnectURL";
import PopUpClearComp from "../DTechComp/PopUpClearComp";
import PopUpTheComp from "../DTechComp/PopUpTheComp";
import { Autocomplete, Button, TextField } from "@mui/material";
import myFunctions from "../myFunctions";
import utilsAdresses from "../_Utils/utilsAdresses";
var scroller = Scroll.scroller;

const AddAddress = (props) => {

    myFunctions.useEscapeKey(props.closeMe);

    const [master, setMaster] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);

    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [userAdds, setUserAdds] = useState([]);

    const [allAds, setAllAds] = useState([]);
    const [thePopUp, setThePopUp] = useState("");

    const [theErrors, setTheErrors] = useState("");
    const [errorsTxts, setErrorsTxts] = useState("");

    const [street, setStreet] = useState("");
    const [num, setNum] = useState("");
    const [appartment, setAppartment] = useState("");
    const [ent, setEnt] = useState("");
    const [city, setCity] = useState("");
    const [flor, setFlor] = useState("");
    const [entryCode, setEntryCode] = useState("");



    const [remarks, setRemarks] = useState("");
    const [delivPrice, setDelivPrice] = useState("");
    const [showAddNew, setShowAddNew] = useState(false);

    const [theSele, setTheSele] = useState("");
    const deliveryCitys = props.deliveryCitys && props.deliveryCitys.length != 0 ? props.deliveryCitys : [];
    const [streetsList, setStreetsList] = useState([]);
    const [streetsWithZone, setStreetsWithZone] = useState([]);
    const [selectedStreet, setSelectedStreet] = useState("");
    const [selectedZone, setSelectedZone] = useState(null);
    const [streetNotCovered, setStreetNotCovered] = useState(false);

    const streetsWithZoneRef = useRef([]);
    const cityNameRef = useRef("");

    useEffect(() => { streetsWithZoneRef.current = streetsWithZone; }, [streetsWithZone]);
    useEffect(() => { cityNameRef.current = city; }, [city]);

    const uniqueCities = deliveryCitys.reduce((acc, c) => {
        const ex = acc.find(x => x.cityName === c.cityName);
        if (!ex) {
            acc.push({ cityName: c.cityName, minPrice: Number(c.deliveryPrice), maxPrice: Number(c.deliveryPrice) });
        } else {
            ex.minPrice = Math.min(ex.minPrice, Number(c.deliveryPrice));
            ex.maxPrice = Math.max(ex.maxPrice, Number(c.deliveryPrice));
        }
        return acc;
    }, []);

    const cityRef = useRef(null);

    let theSelectdAdd = "";
    let popTiming = 0;


    const history = useHistory();



    useEffect(() => {
        cityRef.current?.focus();          // פוקוס אוטומטי על בחירת עיר
    }, []);

    //בדוק שכל התאים של הכתובת תקינים, 
    //או שיוצר הערות או שולח לפונקציה הוספת כתובת 
    const saveAddress = () => {



        let stopMe = false;
        let thEr = "";
        let errs = [];

        if (!city || city === "") {
            thEr = thEr !== "" ? thEr + ",city" : "city";
            errs.push('יש לבחור עיר מהרשימה')
        }
        if (selectedStreet.trim().length <= 1 || (streetsList.length > 0 && !streetsList.find(st => st === selectedStreet))) {
            thEr = thEr !== "" ? thEr + ",street" : "street";
            errs.push('יש לבחור רחוב מהרשימה')
        }
        if (num.trim().length <= 0) {
            thEr = thEr !== "" ? thEr + ",num" : "num";
            errs.push('יש לציין מספר דירה')
        }
        if (streetNotCovered) {
            thEr = thEr !== "" ? thEr + ",street" : "street";
            errs.push('העסק לא מבצע משלוחים לרחוב הזה')
        }

        if (thEr != "") {
            setTheErrors(errs)
            setErrorsTxts(thEr)
        }
        else {
            addNewAddress();
            setErrorsTxts("")
            setTheErrors(errs)

        }
    }

    //הוספת כתובת בדאטה בייס
    const addNewAddress = async () => {
        let citybk = (city != null) ? city : "";
        if (user && user.firstName && user.firstName !== "") {
            let nItem = {
                street: selectedStreet, num, appartment, ent, flor,
                city: citybk, entryCode, remarks, deliveryPrice: delivPrice, zone: selectedZone
            };
            let addAdres = await utilsUsers.addNewAddress(user._id, nItem);
            theSelectdAdd = addAdres[addAdres.length - 1];
            setTheSele(theSelectdAdd);
            setUserAdds(addAdres)
            setUserAdds([addAdres])
            props.setAddrs(addAdres);
        }
        else {

            const newId = Date.now().toString();
            let nItem = {
                specialID: newId,
                street: selectedStreet,
                num, appartment,
                ent, flor,
                city: citybk,
                remarks,
                deliveryPrice: delivPrice,
                entryCode,
                zone: selectedZone
            };
            theSelectdAdd = nItem;
            setTheSele(nItem);
            setUserAdds([nItem])
            props.setAddrs([nItem]);
        }
        //מאפס את כל תיבות הטקסט לאחר הוספת הכתובת
        setStreet("");
        setNum("");
        setAppartment("");
        setEnt("");
        setCity("");
        setFlor("");
        setEntryCode("");
        setRemarks("");
        setTheErrors("");

        props.closeMe();

        //מעלים את הוספת כתובת
        setShowAddNew(false)
    }





    const setTheStreet = (val) => {
        setSelectedStreet(val);
        setStreetNotCovered(false);
        // אזור של העיר (streets) - לפי הרחוב, קודם לכל השאר. רחוב בכמה אזורים - המחיר הגבוה
        // מנצח (כמו restBL.calculateDeliveryPrice)
        const cityEntries = deliveryCitys.filter(c => c.cityName === cityNameRef.current);
        const areaEntry = cityEntries.filter(c => Array.isArray(c.streets) && c.streets.includes(val))
            .reduce((best, c) => (best == null || Number(c.deliveryPrice) > Number(best.deliveryPrice) ? c : best), null);
        if (areaEntry) {
            setSelectedZone(null);
            setDelivPrice(areaEntry.deliveryPrice);
            return;
        }
        const plainEntries = cityEntries.filter(c => !Array.isArray(c.streets));
        if (cityEntries.length > 0 && plainEntries.length === 0) {
            // בעיר הזו העסק מגיע רק לאזורים מהספרייה, והרחוב לא באף אחד מהם
            setDelivPrice("");
            setStreetNotCovered(!!val);
            return;
        }
        if (cityEntries.some(c => Array.isArray(c.streets)) && plainEntries.length === 1 && plainEntries[0].zone == null) {
            setDelivPrice(plainEntries[0].deliveryPrice);
        }
        const streetInfo = streetsWithZoneRef.current.find(s => s.name === val);
        if (streetInfo && streetInfo.zone != null) {
            const zoneEntry = deliveryCitys.find(
                c => c.cityName === cityNameRef.current && !Array.isArray(c.streets) && c.zone == streetInfo.zone
            );
            if (zoneEntry) {
                setSelectedZone(streetInfo.zone);
                setDelivPrice(zoneEntry.deliveryPrice);
            }
        }
    };

    const setTheCity = (val) => {
        if (val !== "בחר") {
            // אזור מהספרייה (streets) - המחיר נקבע רק אחרי בחירת הרחוב
            const cityEntries = deliveryCitys.filter(c => c.cityName === val);
            const isMultiZone = cityEntries.length > 1 || cityEntries.some(c => Array.isArray(c.streets));
            setCity(val);
            setSelectedZone(null);
            setStreetNotCovered(false);
            if (!isMultiZone) {
                const itm = deliveryCitys.find(c => c.cityName === val);
                setDelivPrice(itm.deliveryPrice);
                setTheSele(itm);
            } else {
                setDelivPrice("");
            }
            getCityAdresses(val);
        }
    }

    const getCityAdresses = async (cityName) => {
        const theLst = await utilsAdresses.getStreetsWithZoneByCity(cityName);
        setStreetsWithZone(theLst);
        setStreetsList(theLst.map(s => s.name));
    }

    useEffect(() => {
        if (uniqueCities.length === 1) {
            const only = uniqueCities[0];
            setCity(only.cityName);
            if (only.minPrice === only.maxPrice) setDelivPrice(only.minPrice);
            getCityAdresses(only.cityName);
        }
    }, [deliveryCitys]);



    return (
        <div id={props.addId} className="loginPage">
            <div className="firstMastSec">

                {props.noHead && (
                    <button type="button" className="btnReset sideClosBtn spinOnce" aria-label="סגור" onClick={props.closeMe}>
                        <HighlightOff aria-hidden="true" />
                    </button>
                )}

                <h1 className="bold huge centerText">כתובת למשלוח</h1>
                <br />
                {(errorsTxts != "") &&
                    <div className={"errorLine"}>
                        {
                            errorsTxts.includes("city") ||
                            errorsTxts.includes("address") ||
                            errorsTxts.includes("num") ||
                            <p className={"big bold"}>{"התאים המסומנים הינם חובה"}</p>
                        }
                    </div>
                }

                {(theErrors != "") &&
                    <div id="addAddressFormError" role="alert" className={"errorLine"}>
                        {
                            theErrors.map((itm, indx) => (
                                <p key={indx} className={"vsmall bold"}>- {itm}</p>

                            ))
                        }
                    </div>
                }

                <div className="addAddressBlock" id="newAddress">


                    {/* --- עיר --- */}
                    <div className="usrDet details">
                        <label className="spanCity" htmlFor="addAddrCity">עיר: </label>
                        <select
                            id="addAddrCity"
                            ref={cityRef}
                            className={`connInput ${errorsTxts.includes("city") ? "errorMe" : ""}`}
                            value={city}
                            onChange={(e) => setTheCity(e.target.value)}
                            aria-required="true"
                            aria-invalid={errorsTxts.includes("city")}
                            aria-describedby="addAddressFormError"
                            autoComplete="address-level2"
                        >
                            <option value="בחר" className="customMenuItem">
                                בחר עיר מהרשימה
                            </option>
                            {uniqueCities.map((c, i) => (
                                <option key={i} value={c.cityName} className="customMenuItem">
                                    {c.cityName}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* --- רחוב --- */}
                    <div className="usrDet details">
                        <span className="spanCity">רחוב: </span>
                        <div className="connInputSpec">
                            <Autocomplete
                                freeSolo
                                disablePortal
                                disableClearable
                                options={streetsList}
                                value={selectedStreet}
                                className={`${errorsTxts.includes("street") ? "errorMe" : ""}`}
                                onChange={(_, v) => setTheStreet(v || "")}
                                inputValue={selectedStreet}
                                onInputChange={(_, v) => setTheStreet(v)}
                                ListboxProps={{ sx: { maxHeight: 400, direction: "rtl" } }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="בחר רחוב או הקלד…"
                                        error={errorsTxts.includes("street")}
                                        disabled={!city}
                                        inputProps={{
                                            ...params.inputProps,
                                            'aria-label': 'רחוב',
                                            'aria-required': 'true',
                                            'aria-describedby': 'addAddressFormError',
                                            autoComplete: 'address-line1'
                                        }}
                                    />
                                )}

                            />
                        </div>
                    </div>

                    {/* --- בית / דירה / כניסה / קומה --- */}
                    <div className="usrDet">
                        <div className={`usrDetSmall details ${errorsTxts.includes("num") ? "errorMe" : ""}`}>
                            <label className="sr-only" htmlFor="addAddrNum">בניין/בית</label>
                            <input
                                id="addAddrNum"
                                type="number"
                                className="connInput"
                                value={num}
                                placeholder="בניין/בית"
                                onChange={(e) => setNum(e.target.value)}
                                aria-required="true"
                                aria-invalid={errorsTxts.includes("num")}
                                aria-describedby="addAddressFormError"
                            />
                        </div>
                        <div className={`usrDetSmall details ${errorsTxts.includes("apprtment") ? "errorMe" : ""}`}>
                            <label className="sr-only" htmlFor="addAddrApartment">דירה</label>
                            <input
                                id="addAddrApartment"
                                type="text"
                                className="connInput"
                                value={appartment}
                                placeholder="דירה"
                                onChange={(e) => setAppartment(e.target.value)}
                                aria-required="true"
                                aria-invalid={errorsTxts.includes("apprtment")}
                                aria-describedby="addAddressFormError"
                            />
                        </div>
                        <div className="usrDetSmall details">
                            <label className="sr-only" htmlFor="addAddrEnt">כניסה</label>
                            <input
                                id="addAddrEnt"
                                type="text"
                                className="connInput"
                                value={ent}
                                placeholder="כניסה"
                                onChange={(e) => setEnt(e.target.value)}
                            />
                        </div>
                        <div className="usrDetSmall details">
                            <label className="sr-only" htmlFor="addAddrFlor">קומה</label>
                            <input
                                id="addAddrFlor"
                                type="text"
                                className="connInput"
                                value={flor}
                                placeholder="קומה"
                                onChange={(e) => setFlor(e.target.value)}
                            />
                        </div>
                        <div className="usrDetSmall details">
                            <label className="sr-only" htmlFor="addAddrEntryCode">קוד בכניסה</label>
                            <input
                                id="addAddrEntryCode"
                                type="text"
                                className="connInput"
                                value={entryCode}
                                placeholder="קוד בכניסה"
                                onChange={(e) => setEntryCode(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* --- הערות --- */}
                    <div className="usrDet details">
                        <label className="sr-only" htmlFor="addAddrRemarks">הערות לשליח / קוד לכניסה</label>
                        <textarea
                            id="addAddrRemarks"
                            className="connInput"
                            value={remarks}
                            placeholder="הערות לשליח / קוד לכניסה"
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                    </div>

                    {/* --- כפתור שמירה --- */}
                    <div className="details fullWidth">
                        <button
                            type="button"
                            className="btnReset bold big ConDetailsBtn pointing"
                            onClick={saveAddress}
                        >
                            שמור כתובת
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );


}

export default AddAddress